module.exports = __webpack_public_path__ + "static/logistics-drive-store@3x-8e2c2daa59b14c29d041055331714977.png";